<template>
    <span
        :id="`cnzz_stat_icon_${cid}`"
        :style="conStype"
    ></span>
</template>

<script>
import config from '@config/index';
export default {
    props: {
        hide: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            cid: '1281481522',
        };
    },
    computed: {
        conStype() {
            return {
                display: this.hide ? 'none' : 'inline',
            };
        },
    },
    watch: {
        $route() {
            if (window._czc) {
                let location = window.location;
                let contentUrl = location.pathname + location.hash;
                let refererUrl = '/';
                window._czc.push(['_trackPageview', contentUrl, refererUrl]);
            }
        },
    },
    methods: {
        setCnzz() {
            var script = document.createElement('script'),
                protocol = 'https:' == document.location.protocol ? ' https://' : ' http://';
            script.src = protocol + `v1.cnzz.com/z.js?id=${this.cid}&async=1`;
            script.language = 'javascript';
            document.body.appendChild(script);
        },
    },
    mounted: function () {
        this.setCnzz();
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
